import { PlayerMsgView } from "@quest/murka-games-behavior-leopard";
import { GameParserModel } from "../Platform/GameParserModel";

export class PlayerMsgViewGame extends PlayerMsgView{
    /**
     * overrided to add basegame win amount in freegame amount
     */
    public  showTotalWinMsgInFgBroken() {
        let totalFreeGameWin;
        if (ingenuity.parserModel.getFreeGameBroken()) {
            totalFreeGameWin = ingenuity.parserModel.getFreeSpinAccumulatedWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt();
        }
        else {
            totalFreeGameWin = ingenuity.parserModel.getFreeSpinWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt();
        }
        this.setValueInTotalWinMeter(totalFreeGameWin.toString());
    }
}